import React, { useEffect } from "react";
import {
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import CandidateApplicationForm from "../../../../components/HRMS/RecruitmentTracker/CandidateApplicationForm";
import { RootState } from "../../../../redux/rootReducers";
import { resetSession } from "../../../../redux/auth";
import {
  getSingleRecruitmentTrackerListAction,
  resetHrmsError,
  resetHrmsMessage,
  resetHrmsStatusCode,
  resetHrmsSuccess,
  resetRecruitmentTrackerList,
  resetSingleRecruitmentTrackerList,
  updateRecruitmentTrackerListAction,
} from "../../../../redux/hrms";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import {
  AddRecruitmentTrackerPayloadType,
  GetSingleRecruitmentTrackerPayloadType,
} from "../../../../commonTypes/hrmsTypes";
import { useMenuCheck } from "../../../../customHooks/useMenuCheck";
import {
  resetUsersProfileError,
  resetUsersProfileSuccess,
} from "../../../../redux/usersProfile";
type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  error: string | null;
  success: number | null;
  fetching: boolean;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetHrmsSuccess: () => void;
  dispatchResetHrmsMessage: () => void;
  dispatchResetHrmsError: () => void;
  dispatchResetHrmsStatusCode: () => void;
  dispatchAddRecruitmentTrackerListAction: (data: any) => void;
  dispatchGetSingleRecruitmentTrackerListAction: (data: any) => void;
  dispatchResetSingleRecruitmentTrackerList: () => void;
  singleRecruitmentTrackerList: any;
  dispatchUpdateRecruitmentTrackerListAction: (data: any) => void;
  dispatchResetRecruitmentTrackerList: () => void;
  profileError: string | null;
  profileSuccess: number | null;
  profileStatusCode: number | null;
  dispatchResetUsersProfileError: () => void;
  dispatchResetUsersProfileSuccess: () => void;
};
const EditRecruitmentTracker = ({
  history,
  token,
  success,
  error,
  message,
  fetching,
  dispatchResetSession,
  dispatchResetHrmsSuccess,
  dispatchResetHrmsMessage,
  dispatchResetHrmsError,
  dispatchResetHrmsStatusCode,
  dispatchAddRecruitmentTrackerListAction,
  dispatchGetSingleRecruitmentTrackerListAction,
  dispatchResetSingleRecruitmentTrackerList,
  singleRecruitmentTrackerList,
  dispatchUpdateRecruitmentTrackerListAction,
  dispatchResetRecruitmentTrackerList,
  statusCode,
  profileError,
  profileSuccess,
  profileStatusCode,
  dispatchResetUsersProfileError,
  dispatchResetUsersProfileSuccess,
}: AppProps) => {
  const id = history?.location?.state?.id;
  const multiSelectData = history?.location?.state?.multiSelectData;
  const sortBy = history?.location?.state?.sortBy;
  const searchTerm = history?.location?.state?.searchTerm;
  const activeTab = history?.location?.state?.activeTab;
  const offerMultiSelectData = history?.location?.state?.offerMultiSelectData;
  const offerSortBy = history?.location?.state?.offerSortBy;
  const offerSearchTerm = history?.location?.state?.offerSearchTerm;

  //====================User Management=============================
  const [
    isGetSingleRecruitmentTrackerPresent,
    setIsGetSingleRecruitmentTrackerPresent,
  ] = useMenuCheck();
  //=================================================================

  useEffect(() => {
    dispatchResetHrmsSuccess();
    dispatchResetHrmsMessage();
    dispatchResetHrmsError();
    dispatchResetHrmsStatusCode();
    dispatchResetRecruitmentTrackerList();
    setIsGetSingleRecruitmentTrackerPresent("Get recruitment by id", "menu");
    dispatchResetUsersProfileError();
    dispatchResetUsersProfileSuccess();
  }, []);
  const handleGoBack = () => {
    history?.push({
      pathname: "/hrms/recruitment-module/recruitment-tracker",
      state: {
        multiSelectData,
        sortBy,
        searchTerm,
        activeTab,
        offerMultiSelectData,
        offerSortBy,
        offerSearchTerm,
        isPersist: true,
      },
    });
  };
  useEffect(() => {
    if (id && token) {
      const finalData = {
        token,
        id,
        type: "hrms",
      };
      dispatchGetSingleRecruitmentTrackerListAction(finalData);
    }
  }, [id]);

  const handleRecruitmentTrackerSubmit = (data: any) => {
    if (token) {
      const finalData = {
        token,
        ...data,
        id,
      };
      dispatchUpdateRecruitmentTrackerListAction(finalData);
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetHrmsError();
            }}
          />
        );
      }
    } else if (profileSuccess === 0) {
      if (profileError && profileStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!profileError}
            title="Error"
            message={profileError}
            buttonText="OK"
            onPress={() => {
              dispatchResetUsersProfileError();
            }}
          />
        );
      }
    } else if (
      success === 1 &&
      message === "Recruitment details has been updated successfully."
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Candidate Application Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetRecruitmentTrackerList();
            dispatchResetHrmsSuccess();
            history?.push({
              pathname: "/hrms/recruitment-module/recruitment-tracker",
              state: {
                multiSelectData,
                sortBy,
                searchTerm,
                activeTab,
                offerMultiSelectData,
                offerSortBy,
                offerSearchTerm,
                isPersist: true,
              },
            });
          }}
          statusCode={statusCode}
        />
      );
    }
  };
  return (
    <>
      <div>
        <CommonHeader title="Edit Candidate" />
      </div>
      <ContentArea>
        {isGetSingleRecruitmentTrackerPresent && (
          <CandidateApplicationForm
            handleRecruitmentTrackerSubmit={handleRecruitmentTrackerSubmit}
            handleGoBack={handleGoBack}
            singleRecruitmentTrackerList={singleRecruitmentTrackerList}
            activeTab={activeTab}
            hrmsId={id}
          />
        )}
      </ContentArea>
      <Toaster />
      {handleErrorModal()}

      {/* {fetching && <Loader />} */}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.hrms.success,
  fetching: state.hrms.fetching,
  message: state.hrms.message,
  error: state.hrms.error,
  statusCode: state.hrms.statusCode,
  singleRecruitmentTrackerList: state.hrms.singleRecruitmentTrackerList,
  profileSuccess: state.usersProfile.success,
  profileError: state.usersProfile.error,
  profileStatusCode: state.usersProfile.statusCode,
});
const dispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetHrmsSuccess: () => dispatch(resetHrmsSuccess()),
  dispatchResetHrmsMessage: () => dispatch(resetHrmsMessage()),
  dispatchResetHrmsError: () => dispatch(resetHrmsError()),
  dispatchResetHrmsStatusCode: () => dispatch(resetHrmsStatusCode()),
  dispatchUpdateRecruitmentTrackerListAction: (
    data: AddRecruitmentTrackerPayloadType
  ) => dispatch(updateRecruitmentTrackerListAction(data)),
  dispatchGetSingleRecruitmentTrackerListAction: (
    data: GetSingleRecruitmentTrackerPayloadType
  ) => dispatch(getSingleRecruitmentTrackerListAction(data)),
  dispatchResetSingleRecruitmentTrackerList: () =>
    dispatch(resetSingleRecruitmentTrackerList()),
  dispatchResetRecruitmentTrackerList: () =>
    dispatch(resetRecruitmentTrackerList()),
  dispatchResetUsersProfileError: () => dispatch(resetUsersProfileError()),
  dispatchResetUsersProfileSuccess: () => dispatch(resetUsersProfileSuccess()),
});

export default connect(
  mapStateToProps,
  dispatchToProps
)(EditRecruitmentTracker);
